import React from 'react';
import style from "./style.module.css"
import {NavLink} from "react-router-dom";
import HomeSvg from "../../../../assets/SVG/homeSvg";
import LineSvg from "../../../../assets/SVG/LineSvg";
import langData from "../../../../lang/data";
const DetailsTitle = ({detailsList ,currentLanguage}) => {
    return <div className={style.sales_block_svg_title}>
        <NavLink>
            <HomeSvg/>
        </NavLink>
        <span>
          {" "}
            <LineSvg/>
        </span>
        <h3>{langData.titles.Sales[currentLanguage]}</h3>
        <LineSvg/>
        {detailsList?.sale ?
            <h3>{detailsList?.sale?.['name_' + currentLanguage]}</h3>
            : null}

    </div>
};

export default DetailsTitle;